/*@flow*/
import React from 'react';
import Hours from 'comps/Hours';
import hash from 'lib/hash';
import list from 'lib/proforma/templates/List';
import type { LocalsT } from 'lib/proforma/types';

export default (list.clone({
  AddButton() {
    return null;
  },
  Row({ row }) {
    return <div className="hide">{row.input}</div>;
  },
  Fieldset: (props: LocalsT & { hideLabel?: boolean }) => {
    const { children, onChange, value, disabled, label, hideLabel } = props;
    const newProps = {
      className: 'fieldset fieldset-depth-2',
      disabled,
    };
    const legend =
      label && !hideLabel ? (
        <label className="col-form-label">{label}</label>
      ) : null;

    return (
      <fieldset {...newProps} style={{ marginBottom: 15 }}>
        {legend}
        {children}
        <Hours
          days={value}
          onChange={v => {
            if (hash(v) === hash(value)) return;
            onChange(v);
          }}
        />
      </fieldset>
    );
  },
}): any);
